import {
  FETCH_ALL_USERS,
  FETCH_ALL_USERS_SUCCESS,
  FETCH_ALL_USERS_FAILED,
  EDIT_USER,
  EDIT_USER_SUCCESS,
  EDIT_USER_FAILED,
  DELETE_USER,
  DELETE_USER_SUCCESS,
  DELETE_USER_FAILED,
  FETCH_ALL_USERS_STATIC,
  FETCH_ALL_USERS_STATIC_SUCCESS,
  FETCH_ALL_USERS_STATIC_FAILED,
  USER_DELETED,
  FETCH_ALL_DRIVERS,
  FETCH_ALL_DRIVERS_SUCCESS,
  FETCH_ALL_DRIVERS_FAILED
} from "../store/types";
import { firebase } from '../config/configureFirebase';
import { onValue, set, push, update, off, get, remove } from "firebase/database";
import { uploadBytesResumable, getDownloadURL } from "firebase/storage";
import { signOut } from "firebase/auth";

export const fetchUsers = () => (dispatch) => {

  const {
    usersRef,
    allLocationsRef
  } = firebase;

  // Clean up any existing listeners first
  off(usersRef);
  off(allLocationsRef);

  dispatch({
    type: FETCH_ALL_DRIVERS,
    payload: null
  });
  
  const unsubscribe = onValue(usersRef, async snapshot => {
    if (snapshot.val()) {
      const locationdata = await get(allLocationsRef);
      const locations = locationdata.val();
      const data = snapshot.val();
      const arr = Object.keys(data)
      .filter(i => data[i].usertype!='admin')
      .map(i => {
        data[i].id = i;
        data[i].location = locations && locations[i] ? locations[i] : null;
        return data[i];
      });
      dispatch({
        type: FETCH_ALL_USERS_SUCCESS,
        payload: arr
      });
    } else {
      dispatch({
        type: FETCH_ALL_USERS_FAILED,
        payload: "No users available."
      });
    }
  });

  // Return cleanup function
  return () => {
    off(usersRef);
    off(allLocationsRef);
    if (unsubscribe) {
      unsubscribe();
    }
  };
};


export const fetchUsersOnce = () => async (dispatch) => {

  const {
    usersRef
  } = firebase;

  dispatch({
    type: FETCH_ALL_USERS_STATIC,
    payload: null
  });
  
  try {
    const usersSnapshot = await get(usersRef);
    
    if (usersSnapshot.val()) {
      const data = usersSnapshot.val();
      const arr = Object.keys(data)
      .map(i => {
        data[i].id = i;
        return data[i];
      });
      dispatch({
        type: FETCH_ALL_USERS_STATIC_SUCCESS,
        payload: arr
      })
    } else {
      dispatch({
        type: FETCH_ALL_USERS_STATIC_FAILED,
        payload: "No users available."
      });
    }
  } catch (error) {
    dispatch({
      type: FETCH_ALL_USERS_STATIC_FAILED,
      payload: "Error fetching data: " + error.message
    });
  }
};
export const clearFetchDrivers = () => (dispatch) => {
  const {
    driversRef,
    allLocationsRef,
  } = firebase;
  firebase.off(driversRef);
  firebase.off(allLocationsRef);
}

export const fetchDrivers = (appType) => async(dispatch) => {

  const {
    driversRef,
    allLocationsRef,
    settingsRef
  } = firebase;

  // Clean up any existing listeners first
  off(driversRef);
  off(allLocationsRef);

  const settingsdata = await get(settingsRef);
  const settings = settingsdata.val();

  dispatch({
    type: FETCH_ALL_USERS,
    payload: null
  });

  let locationUnsubscribe = null;
  let driversUnsubscribe = null;

  // Use once for app type or non-realtime, otherwise use realtime listeners
  const useOnce = appType === 'app' || !(settings && settings.realtime_drivers);
  
  const processData = (driversSnapshot, locationsSnapshot) => {
    const locations = locationsSnapshot.val();
    const data = driversSnapshot.val();
    
    if (data) {
      const arr = Object.keys(data)
        .filter(i => data && data[i].approved == true && data[i].driverActiveStatus == true && locations && locations[i] && ( (data[i].licenseImage && settings.license_image_required) || !settings.license_image_required)
                    && (((data[i].carApproved && settings.carType_required) || !settings.carType_required) || !settings.carType_required) && ((data[i].term && settings.term_required) || !settings.term_required) ) 
        .map(i => {
          return {
            id: i,
            location: locations && locations[i] ? locations[i]:null,
            carType: data[i].carType ? data[i].carType : null,
            vehicleNumber:  data[i].vehicleNumber ? data[i].vehicleNumber : null,
            fleetadmin:  data[i].fleetadmin ? data[i].fleetadmin : null,
            firstName: data[i].firstName,
            lastName: data[i].lastName,
            queue: data[i].queue
          };
        });
      dispatch({
        type: FETCH_ALL_DRIVERS_SUCCESS,
        payload: arr
      });
    } else {
      dispatch({
        type: FETCH_ALL_DRIVERS_FAILED,
        payload: "No users available."
      });
    }
  };

  if (useOnce) {
    // Fetch both datasets once and process them
    try {
      const [driversSnapshot, locationsSnapshot] = await Promise.all([
        get(driversRef),
        get(allLocationsRef)
      ]);
      processData(driversSnapshot, locationsSnapshot);
    } catch (error) {
      dispatch({
        type: FETCH_ALL_DRIVERS_FAILED,
        payload: "Error fetching data: " + error.message
      });
    }
  } else {
    // Set up realtime listeners
    driversUnsubscribe = onValue(driversRef, async (driversSnapshot) => {
      if (driversSnapshot.val()) {
        try {
          const locationsSnapshot = await get(allLocationsRef);
          processData(driversSnapshot, locationsSnapshot);
        } catch (error) {
          dispatch({
            type: FETCH_ALL_DRIVERS_FAILED,
            payload: "Error fetching locations: " + error.message
          });
        }
      } else {
        dispatch({
          type: FETCH_ALL_DRIVERS_FAILED,
          payload: "No users available."
        });
      }
    });
  }

  // Return cleanup function
  return () => {
    off(driversRef);
    off(allLocationsRef);
    if (driversUnsubscribe) {
      driversUnsubscribe();
    }
    if (locationUnsubscribe) {
      locationUnsubscribe();
    }
  };
};

export const addUser = (userdata) => (dispatch) => {
  const {
    usersRef
  } = firebase;

  dispatch({
    type: EDIT_USER,
    payload: userdata
  });

  delete userdata.tableData;

  push(usersRef, userdata).then(() => {
    dispatch({
      type: EDIT_USER_SUCCESS,
      payload: null
    });
  }).catch((error) => {
    dispatch({
      type: EDIT_USER_FAILED,
      payload: error
    });
  });
}

export const editUser = (id, user) => (dispatch) => {

  const {
    singleUserRef
  } = firebase;

  dispatch({
    type: EDIT_USER,
    payload: user
  });
  let editedUser = user;
  delete editedUser.id;
  delete editedUser.tableData;
  set(singleUserRef(id), editedUser);
}

export const updateUserCar = (id, data) => (dispatch) => {
  const {
    singleUserRef
  } = firebase;

  dispatch({
    type: EDIT_USER,
    payload: data  
  });
  update(singleUserRef(id),data);
}

export const updateLicenseImage = (uid, imageBlob, imageType) => async (dispatch) => {

  const {
    singleUserRef,
    driverDocsRef,
    driverDocsRefBack,
    verifyIdImageRef
  } = firebase;

  let profile = {};
  if(imageType === 'licenseImage'){
    await uploadBytesResumable(driverDocsRef(uid),imageBlob);
    let image = await getDownloadURL(driverDocsRef(uid));
    profile.licenseImage = image;
  }
  if(imageType === 'licenseImageBack'){
    await uploadBytesResumable(driverDocsRefBack(uid),imageBlob);
    let image1 = await getDownloadURL(driverDocsRefBack(uid));
    profile.licenseImageBack = image1;
  }
  if(imageType === 'verifyIdImage'){
    await uploadBytesResumable(verifyIdImageRef(uid),imageBlob);
    let image1 = await getDownloadURL(verifyIdImageRef(uid));
    profile.verifyIdImage = image1;
  }
  update(singleUserRef(uid),profile);
  dispatch({
    type: EDIT_USER,
    payload: uid
  });
};

export const deleteUser = (uid) => (dispatch) => {

  const {
    auth,
    walletHistoryRef,
    singleUserRef,
    userNotificationsRef,
    carsRef,
    carEditRef
  } = firebase;

  dispatch({
    type: DELETE_USER,
    payload: uid
  });

  if (auth.currentUser.uid === uid) {
    firebase.off(singleUserRef(uid));
    firebase.off(walletHistoryRef(uid));
    firebase.off(userNotificationsRef(uid));
  }

  get(singleUserRef(uid)).then(userdata => {
    const profile = userdata.val();
    if(profile && profile.usertype === 'driver'){
      get(carsRef(uid, profile.usertype)).then(carssnapshot => {
        let cars = carssnapshot.val();
        if (cars) {
          const arr = Object.keys(cars);
          for(let i = 0; i < arr.length; i++){
            remove(carEditRef(arr[i]));
          }
        }
      });
    } 
    
    remove(singleUserRef(uid)).then(() => {
      if (auth.currentUser.uid === uid) {
        signOut(auth);
        dispatch({
          type: USER_DELETED,
          payload: null
        });
      } else {
        dispatch({
          type: DELETE_USER_SUCCESS,
          payload: null
        });
      }
    }).catch((error) => {
      dispatch({
        type: DELETE_USER_FAILED,
        payload: error
      });
    });
  }).catch((error) => {
    dispatch({
      type: DELETE_USER_FAILED,
      payload: error
    });
  });
}
